export const FIREBASE_API_KEY = "AIzaSyDGQwZaM6R0Q8ywHxLVdvcMstjFcd-tvPQ";
export const FIREBASE_AUTH_DOMAIN = "twl-prod.firebaseapp.com";
export const FIREBASE_DATABASE_URL = "https://twl-prod.firebaseio.com";
export const FIREBASE_PROJECT_ID = "twl-prod";
export const FIREBASE_STORAGE_BUCKET = "twl-prod.appspot.com";
export const FIREBASE_MESSAGING_SENDER_ID = "596567013639";

export const TW_API_URL = "https://trenchwars.org/api";

export const SEASON_ID = "2024-winter"; // the tblLeague__Season.fcSeasonID field, used by the API
export const SEASON_NAME = "Season 2";
export const CURRENT_WEEK = 6;
export const LOGO_IMG = "https://i.imgur.com/y5FJvR4.png";
export const NO_TEAM_IMG = "https://i.imgur.com/EtAkIoS.png";
export const FORUMS_URL = "https://forums.trenchwars.com/forum/sscu-trench-wars-forums/dueling-cup";
export const RULES_URL =
  "https://forums.trenchwars.com/forum/sscu-trench-wars-forums/dueling-cup/1364990-tw-league-cup-2024-announcement";
export const TWLM_URL = "https://www.trenchwars.org/TWLM/v2";

/*
This is mapping for team participation for each TWL division.
The ids listed as the array keys correspond to tblLeague__Team.fnTeamID
*/
export const TEAM_PARTICIPATION = {
  twld: [
    33, // Justice
    34, // Blood
    35, // Supreme
    36, // Filthy
    37, // Thunder
    38, // Stray
  ],
  twlj: [
    33, // Justice
    34, // Blood
    35, // Supreme
    37, // Thunder
    39, // Kobe
    40, // Terrorist
  ],
  twlb: [
    
    33, // Justice
    34, // Blood
    37, // Thunder
    40, // Terrorist
    41, // Dun vs Me
    42, // Resistance
  ],
};



// WEBPACK FOOTER //
// ./src/config.js